module.exports = __webpack_public_path__ + "img/nodata.0c92b1e5.png";